import {SEARCHFORM_TRANSLATION_KEYS} from './translationsKeys';
import {SEARCHFORM_FALLBACK_TRANSLATIONS} from './fallbackTranslations';

const CATEGORY = 'messages';
const MessageReader = require('@homeaway/stab-message-reader');

export function init() {
    if (typeof require.ensure !== 'function') {
        require.ensure = (d, c) => c(require);
    }
}

init();

const I18n = {
    /**
      * Loads messages file
      * @param locale lang name to use as suffix to resolve file path
      * @returns Promise resolved when language file has been loaded
      */
    load(locale) {
        MessageReader.setLocale(locale);
        return new Promise((resolve) =>
            require.ensure(
                [],
                () => resolve(require(`../resources/compiled/${locale}`))
            )
        );
    },
    /**
      * Read a message via a key and variable options object
      * @param key String
      * @param options Object containing name/value pairs
      * @category lingua key category
      */
    read(key, options, category) {
        return MessageReader.read(key, options, category);
    },
    /**
      * Read a message if it exists via a key and variable options object
      * @param key String
      * @param options Object containing name/value pairs
      * @category lingua key category
      */
    readIfExists(key, options, category) {
        if (typeof category === 'undefined') {
            category = CATEGORY;
        }

        return this.exists(key) ? this.read(key, options, category) : null;
    },
    /**
      * Determine if a key is supported for the current locale
      * @param key String
      * @return keyExists Boolean
      */
    exists(key) {
        return MessageReader.exists(key, CATEGORY);
    },
};


const readTranslationsBundles = function () {
    let transBundles = {};
    const bundles = Object.assign({}, SEARCHFORM_TRANSLATION_KEYS);
    Object.keys(bundles).forEach((val) => {
        transBundles[val] = I18n.readIfExists(bundles[val]);
    });
    return transBundles;
};

async function getLabels(locale) {
    try {
        await I18n.load(locale);
        return readTranslationsBundles();
    } catch (e) {
        return SEARCHFORM_FALLBACK_TRANSLATIONS;
    }
}

const handleLocale = function (locale) {
    if (!locale) {
        return 'en_US';
    }

    const updatedLocale = locale.split('_');
    if (updatedLocale.length === 3) {
        return updatedLocale [0].concat('_', updatedLocale [1]);
    }

    return locale;
};

export {getLabels, I18n, readTranslationsBundles, handleLocale};
